/* eslint-disable @typescript-eslint/no-unsafe-return,
      no-param-reassign,
      no-return-assign */
import { ActionType } from '../action-types';
import { Action } from '../actions';

interface InitialStateI {
  isLoading: boolean,
  isSuccess: boolean,
  isFormVisible: boolean,
  isFailure: boolean,
  isConsent: any,
  isEmailPreference:boolean,
}

const initialState: InitialStateI = {
  isLoading: false,
  isSuccess: false,
  isFormVisible: true,
  isFailure: false,
  isConsent: null,
  isEmailPreference: false,
};

export const appReducer = (state: InitialStateI = initialState, action: Action) => {
  switch (action.type) {
  case ActionType.ISLOADING: {
    return { ...state, isLoading: true };
  }
  case ActionType.ISLOADED: {
    return { ...state, isLoading: false };
  }
  case ActionType.ISFORMVISIBLE: {
    return { ...state, isFormVisible: action.payload };
  }
  case ActionType.ISSUCCESS: {
    return { ...state, isSuccess: true };
  }
  case ActionType.ISFAILURE: {
    return { ...state, isFailure: true };
  }
  case ActionType.VALIDATE: {
    return { ...state, isConsent: action.payload };
  }
  case ActionType.ISEMAILPREFERENCE: {
    return { ...state, isEmailPreference: true };
  }
  default:
    return state;
  }
};
